import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ProviderFoundImage from "../../../assets/images/provider-found.png";
import ProviderNotFoundImage from "../../../assets/images/provider-not-found.png";
import ProviderFoundImageWebp from "../../../assets/images/provider-found.webp";
import ProviderNotFoundImageWebp from "../../../assets/images/provider-not-found.webp";
import Highlight from "../../../components/highlight";
import useLoadImage from "../../../utils/useLoadImage";
import LoadingScreen from "../../general/loading-screen";
import { HeadlineMedium } from "../../../components/font";
import HeadingContainer from "../../../layout/heading-container";
import { Button, IllustrationPuzzle, IllustrationSearch } from "@manifesthhqinc/ui-library";
import { VectorWrapperDiv } from "../../../components/vector-wrapper/styles";

const ProviderSearch: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, onClickContinue, currentOldAccountDetails, isSaving, setIsSaving } = props;
  const { imageSrc, webpSrc } = useLoadImage({
    imgSrc: currentOldAccountDetails.providerName ? ProviderFoundImage : ProviderNotFoundImage,
    webp: currentOldAccountDetails.providerName ? ProviderFoundImageWebp : ProviderNotFoundImageWebp,
  });

  const onClickContinueHandler = () => {
    setIsSaving(true);
    onClickContinue();
  };

  if (process.env.NODE_ENV !== "test" && !imageSrc && !webpSrc) {
    return <LoadingScreen loadingScreenMessage="" />;
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar>
            <HeadlineMedium $textAlign="center">
              {currentOldAccountDetails.providerName ? (
                <>
                  It looks like <Highlight>{currentOldAccountDetails.planSponsor}</Highlight> used{" "}
                  <Highlight>{currentOldAccountDetails.providerName}</Highlight>
                </>
              ) : (
                `We're looking into it now!`
              )}
            </HeadlineMedium>
          </HeadingContainer>
          <VectorWrapperDiv $marginTop={-30}>
            {currentOldAccountDetails.providerName ? (
              <IllustrationPuzzle width={260} height={260} />
            ) : (
              <IllustrationSearch width={260} height={260} />
            )}
          </VectorWrapperDiv>
        </Container>
      </ScrollableContainer>
      <Footer>
        <p className="text-center disclaimer-text">
          {currentOldAccountDetails.providerName
            ? `We're on it! Manifest will verify your information since employers sometimes change providers.`
            : `Manifest leverages a variety of resources to find old accounts. After searching our databases, we'll update you.`}
        </p>
        <Button name="continue" onClick={onClickContinueHandler} isLoading={isSaving} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ProviderSearch;
